// src/api/notification.network.ts
import { http } from './http.ts';
import { ENDPOINTS } from './endpoints.ts';

export const NotificationNetwork = {
  getList: (page: number, perPage: number) =>
    http.get(ENDPOINTS.notification.list, { params: { page, per_page: perPage } }),

  markRead: (id?: number) =>
    id != null
      ? http.patch(ENDPOINTS.notification.item(id))
      : http.patch(ENDPOINTS.notification.markAllRead),

  remove: (id?: number) =>
    id != null
      ? http.delete(ENDPOINTS.notification.item(id))
      : http.delete(ENDPOINTS.notification.deleteAll),

  checkNew: () =>
    http.get(ENDPOINTS.dashboard.newNotifications),
};
